import styled, { css } from '@app/styled';
import { modifier, spacing } from '@app/theme';

export const Container = styled.div`
    position: relative;
`;

type TabForm = {
    $minified?: boolean;
};

export const TabForm = styled.div<TabForm>`
    padding-top: ${spacing(7)};
    min-height: 380px;
    display: grid;
    row-gap: ${spacing(6)};
    align-items: flex-start;
    grid-auto-rows: 0fr;

    ${modifier(
        '$minified',
        css`
            padding-top: ${spacing(0)};
            min-height: auto;
            row-gap: ${spacing(5)};
        `,
    )}
`;

export const RadioWrapper = styled.div`
    display: grid;
    row-gap: ${spacing(2)};
`;

export const FormContainer = styled.div`
    padding-top: ${spacing(7)};
`;
